





















































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import AsesmenAwalBayiBaruLahirSvc from "@/services/AsesmenAwalBayiBaruLahir";
import AsesmenAwalBayiBaruLahirStore from "@/store/modules/AsesmenAwalBayiBaruLahirStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import moment from "moment";
import {
  DUBOWITZ_NEURO_ITEMS,
  DUBOWITZ_FISIK_ITEMS,
  dubowitzToGestationalAge,
  gestationalChipColor,
  gestationalLabel
} from "@/utils/dubowitzScore";
import IdentitasBayiBaruLahirSvc from "@/services/IdentitasBayiBaruLahir";
import { identitasApgarKomponen, identitasToAsesmenBbl } from "@/utils/identitasBbl";

@Component({
  components: { CardModalTtd },
  filters: {
    formatDatetime(val) {
      if (!val) return "-";
      return moment(val).format("DD-MM-YYYY HH:mm");
    }
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAsesmenBayiBaruLahir extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  // Konteks pintu masuk dari Asesmen Awal Kebidanan (record ibu).
  // Jika diisi, asesmen BBL ini ditautkan ke register ibu (mendukung kembar).
  @Prop({ default: null }) readonly ibuRegister!: number;
  @Prop({ default: null }) readonly ibuRm!: number | string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canSave(): boolean {
    if (this.readOnly) return false;
    const action = this.isEditing ? "edit" : "create";
    return userModule.canAccessForm("asesmen_awal_bbl", action);
  }

  @Prop({ default: false }) readonly isActive!: boolean;
  @Ref() readonly dateTimePicker;

  saving = false;
  removing = false;
  isEditing = false;
  modalTtd = false;
  signRole = "dokter";
  examinedAt = null;
  jamLahir = null;
  deceasedAt = null;

  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  timePickerProps = { format: "24hr", scrollable: true };

  sikapBayiOptions = ["Fleksi", "Ekstensi", "Abnormal"];
  refleksOptions = ["Positif", "Negatif", "Positif Asimetris", "Lemah"];

  jenisKelahiranOptions = [
    { text: "Tunggal", value: "tunggal" },
    { text: "Kembar", value: "kembar" }
  ];
  statusBayiOptions = [
    { text: "Hidup", value: "hidup" },
    { text: "Mati", value: "mati" }
  ];
  bbUkOptions = [
    { text: "SGA (<P10)", value: "sga" },
    { text: "AGA (P10–P90)", value: "aga" },
    { text: "LGA (>P90)", value: "lga" }
  ];
  skriningOptions = ["Belum", "Normal", "Refer / Positif", "Tidak Dilakukan"];

  apgarKomponen = {
    djantung: "Denyut Jantung",
    napas: "Pernapasan",
    tonus: "Tonus Otot",
    reflex: "Peka Rangsang",
    warna: "Warna Kulit"
  };
  apgarWaktu = {
    menit_1: "1 Menit",
    menit_5: "5 Menit",
    menit_10: "10 Menit"
  };
  resusitasiLabels = {
    langkah_awal: "Langkah Awal (hangatkan/posisi/bersihkan/keringkan/stimulasi)",
    suction: "Penghisapan Lendir",
    oksigen: "O₂ Sungkup / Nasal Kanul",
    vtp: "VTP (Ventilasi Tekanan Positif)",
    kompresi: "Kompresi Dada (3:1)",
    intubasi: "Intubasi Endotrakeal",
    obat: "Obat Resusitasi (adrenalin/cairan)",
    akses_vena: "Akses Vena (UVC/perifer/IO)"
  };
  esensialLabels = {
    imd: "Inisiasi Menyusu Dini (IMD)",
    salep_mata: "Salep Mata Antibiotika (≤1 jam)",
    vit_k: "Injeksi Vitamin K1 (≤1 jam)",
    hb0: "Imunisasi Hepatitis B-0 (≤24 jam)",
    hbig: "Profilaksis HBIG (ibu HBsAg+)",
    arv: "Profilaksis ARV (ibu HIV+)",
    tali_pusat: "Perawatan Tali Pusat (dry cord care)",
    hipotermia: "Pencegahan Hipotermia"
  };
  skriningLabels = {
    shk: "SHK (Hipotiroid Kongenital / TSH)",
    g6pd: "G6PD",
    oae: "Pendengaran (OAE / AABR)",
    cchd: "CCHD (Pulse Oxymetri)"
  };

  organLabels = {
    kulit: "Kulit",
    kepala: "Kepala",
    mata: "Mata",
    hidung: "Hidung",
    telinga: "Telinga",
    mulut_lidah: "Mulut / Lidah",
    leher: "Leher",
    dada: "Dada",
    jantung: "Jantung",
    paru: "Paru",
    perut: "Perut",
    hati: "Hati",
    limpa: "Limpa",
    anus: "Anus",
    genital: "Genital"
  };

  ekstremitasLabels = {
    superior_kanan: "Superior Kanan",
    superior_kiri: "Superior Kiri",
    inferior_kanan: "Inferior Kanan",
    inferior_kiri: "Inferior Kiri"
  };

  refleksLabels = {
    moro: "R. Moro",
    memegang: "R. Memegang",
    menghisap: "R. Menghisap",
    tonik_leher: "R. Tonik Leher",
    plantar: "R. Plantar"
  };

  neuroLabels = {
    sikap_posture: "Sikap (Posture)",
    sudut_radiokarpal: "Sudut Radiokarpal",
    arm_recoil: "Arm Recoil",
    dorsofleksi_tumit: "Dorsofleksi Tumit",
    sudut_poplitea: "Sudut Poplitea",
    leg_recoil: "Leg Recoil",
    heel_to_ear: "Heel to Ear",
    scarf_sign: "Scarf Sign",
    head_lag: "Head-lag",
    ventral_suspension: "Ventral Suspension"
  };

  fisikLabels = {
    udem: "Udem",
    elastisitas_kulit: "Elastisitas Kulit",
    warna_kulit: "Warna Kulit",
    venae_abdomen: "Venae Abdomen",
    lanugo: "Lanugo",
    lipat_plantar: "Lipat Plantar",
    papila_mamae: "Papila Mamae",
    kelenjar_mamae: "Kelenjar Mamae",
    bentuk_telinga: "Bentuk Telinga",
    konsistensi_telinga: "Konsistensi Telinga",
    organ_genitalia: "Organ Genitalia"
  };

  neuroItems = DUBOWITZ_NEURO_ITEMS;
  fisikItems = DUBOWITZ_FISIK_ITEMS;

  form = this.getEmptyForm();

  // ==================== COMPUTED ====================

  get record() {
    return AsesmenAwalBayiBaruLahirStore.asesmen;
  }

  get loading() {
    return AsesmenAwalBayiBaruLahirStore.loading;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get stateUser() {
    return userModule.user;
  }

  get dokterNama(): string {
    if (!this.record || !this.record.dokter || !this.record.dokter.identitas) return "-";
    return this.record.dokter.identitas.nama || "-";
  }

  get ppjaNama(): string {
    if (!this.record || !this.record.ppja || !this.record.ppja.identitas) return "-";
    return this.record.ppja.identitas.nama || "-";
  }

  get canEdit(): boolean {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (!userModule.canAccessForm("asesmen_awal_bbl", "edit")) return false;
    return !this.record.signed_dokter;
  }

  get canDelete(): boolean {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (!userModule.canAccessForm("asesmen_awal_bbl", "edit")) return false;
    return !alasanTtdMengunciHapus(
      this.record.creator_user_id,
      [{ ditandatangani: this.record.signed_dokter, penandaTanganId: this.record.dokter_id }],
      userModule.user?.id
    );
  }

  get canSign(): boolean {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (this.record.signed_dokter) return false;
    return this.stateUser?.id === this.record.dokter_id;
  }

  get canSignPpja(): boolean {
    if (this.readOnly) return false;
    if (!this.record) return false;
    if (this.record.signed_ppja) return false;
    // PPJA (penanggung jawab asuhan) berbeda dari dokter penandatangan
    return this.stateUser?.id !== this.record.dokter_id;
  }

  get dubowitzNeuroTotal(): number {
    return Object.values(this.form.dubowitz_neuro).reduce((sum: number, val) => sum + (Number(val) || 0), 0) as number;
  }

  get dubowitzFisikTotal(): number {
    return Object.values(this.form.dubowitz_fisik).reduce((sum: number, val) => sum + (Number(val) || 0), 0) as number;
  }

  get dubowitzTotal(): number {
    return this.dubowitzNeuroTotal + this.dubowitzFisikTotal;
  }

  get taksiranUmurKehamilan(): number | null {
    if (this.dubowitzTotal === 0 && !this.hasAnyDubowitzInput) return null;
    return this.dubowitzToGestationalAge(this.dubowitzTotal);
  }

  get hasAnyDubowitzInput(): boolean {
    const neuroVals = Object.values(this.form.dubowitz_neuro);
    const fisikVals = Object.values(this.form.dubowitz_fisik);
    return [...neuroVals, ...fisikVals].some(v => v !== null && v !== undefined && v !== "");
  }

  get formattedExaminedAt(): string {
    return this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");
  }

  get formattedJamLahir(): string | null {
    return this.jamLahir ? moment(this.jamLahir).format("YYYY-MM-DD HH:mm:ss") : null;
  }

  get formattedDeceasedAt(): string | null {
    return this.deceasedAt ? moment(this.deceasedAt).format("YYYY-MM-DD HH:mm:ss") : null;
  }

  // ---- Preview klasifikasi & APGAR (final tetap dihitung server) ----
  get klasifikasiGestasiPreview(): string {
    const m = Number(this.form.usia_kehamilan_minggu);
    if (!this.form.usia_kehamilan_minggu && this.form.usia_kehamilan_minggu !== 0) return "-";
    if (m < 32) return "Sangat Preterm (<32 mgg)";
    if (m < 37) return "Preterm (32 – <37 mgg)";
    if (m < 42) return "Aterm (37 – <42 mgg)";
    return "Postterm (≥42 mgg)";
  }

  get klasifikasiBeratPreview(): string {
    const g = Number(this.form.berat_lahir_gram);
    if (!g) return "-";
    if (g < 1000) return "BBLASR (<1000 g)";
    if (g < 1500) return "BBLSR (<1500 g)";
    if (g < 2500) return "BBLR (<2500 g)";
    return "BBLN (≥2500 g)";
  }

  apgarTotal(waktu: string): number | null {
    const komp = this.form.apgar[waktu] || {};
    const vals = Object.values(komp).filter(v => v !== null && v !== undefined && v !== "");
    if (vals.length === 0) return null;
    return vals.reduce((s: number, v) => s + (Number(v) || 0), 0) as number;
  }

  get apgarInterpretasiPreview(): string {
    const a5 = this.apgarTotal("menit_5");
    if (a5 === null) return "-";
    if (a5 >= 7) return "Vigorous / Normal (7–10)";
    if (a5 >= 4) return "Asfiksia Ringan-Sedang (4–6)";
    return "Asfiksia Berat (0–3)";
  }

  apgarRange = [0, 1, 2];

  // ==================== LIFECYCLE ====================

  mounted() {
    this.loadData();
  }

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val && !this.record) {
      this.loadData();
    }
  }

  // ==================== METHODS ====================

  async loadData() {
    await AsesmenAwalBayiBaruLahirStore.getByRegister(this.register);
    if (this.record) {
      this.populateForm();
    } else {
      await this.applyIdentitasBbl(true);
    }
  }

  async applyIdentitasBbl(silent = false) {
    const d = await IdentitasBayiBaruLahirSvc.findByRegisterSilent(this.register);
    if (!d) {
      if (!silent) appModule.sendErrorAlert("Identitas Bayi Baru Lahir belum diisi");
      return;
    }
    const m = identitasToAsesmenBbl(d);
    if (m.berat_lahir_gram !== null) this.form.berat_lahir_gram = m.berat_lahir_gram;
    if (m.panjang_badan_cm !== null) this.form.panjang_badan_cm = m.panjang_badan_cm;
    if (m.lingkar_kepala_cm !== null) this.form.lingkar_kepala_cm = m.lingkar_kepala_cm;
    if (m.lingkar_dada_cm !== null) this.form.lingkar_dada_cm = m.lingkar_dada_cm;
    if (m.jam_lahir) this.jamLahir = m.jam_lahir;
    if (m.jenis_kelahiran) this.form.jenis_kelahiran = m.jenis_kelahiran;
    if (m.status_bayi) this.form.status_bayi = m.status_bayi;
    const k = identitasApgarKomponen(d);
    ["menit_1", "menit_5"].forEach(w => {
      const src = k[w];
      if (!src) return;
      const cur = this.form.apgar[w] || {};
      const kosong = Object.keys(cur).every(x => cur[x] === null || cur[x] === undefined);
      if (kosong) this.form.apgar[w] = { ...cur, ...src };
    });
    if (!silent) appModule.NoticeDelay("Data diambil dari Identitas Bayi Baru Lahir");
  }

  populateForm() {
    const r = this.record;
    if (!r) return;

    this.examinedAt = r.examined_at ? new Date(r.examined_at) : null;
    this.jamLahir = r.jam_lahir ? new Date(r.jam_lahir) : null;
    this.deceasedAt = r.deceased_at ? new Date(r.deceased_at) : null;
    this.form.sikap_bayi = r.sikap_bayi;
    this.form.nadi = r.nadi;
    this.form.suhu = r.suhu;
    this.form.pernapasan = r.pernapasan;
    this.form.diagnosis = r.diagnosis;
    this.form.rencana_tindakan = r.rencana_tindakan;
    this.form.dokter_id = r.dokter_id;

    // Identitas & antropometri & klasifikasi (kolom khusus)
    this.form.jenis_kelahiran = r.jenis_kelahiran;
    this.form.urutan_kembar = r.urutan_kembar;
    this.form.status_bayi = r.status_bayi || "hidup";
    this.form.berat_lahir_gram = r.berat_lahir_gram;
    this.form.panjang_badan_cm = r.panjang_badan_cm;
    this.form.lingkar_kepala_cm = r.lingkar_kepala_cm;
    this.form.lingkar_dada_cm = r.lingkar_dada_cm;
    this.form.usia_kehamilan_minggu = r.usia_kehamilan_minggu;
    this.form.usia_kehamilan_hari = r.usia_kehamilan_hari;
    this.form.klasifikasi_bb_uk = r.klasifikasi_bb_uk;
    this.form.resusitasi_dilakukan = !!r.resusitasi_dilakukan;

    const content = r.content || {};
    const empty = this.getEmptyForm();
    this.form.anamnesis = { ...empty.anamnesis, ...(content.anamnesis || {}) };
    this.form.pemeriksaan_fisik = { ...empty.pemeriksaan_fisik, ...(content.pemeriksaan_fisik || {}) };
    this.form.kelainan_lain = content.kelainan_lain || "";

    // Section komprehensif
    if (content.apgar) {
      ["menit_1", "menit_5", "menit_10"].forEach(w => {
        this.form.apgar[w] = { ...empty.apgar[w], ...(content.apgar[w] || {}) };
      });
    }
    if (content.resusitasi) {
      this.form.resusitasi = { ...empty.resusitasi, ...content.resusitasi };
    }
    if (content.neonatal_esensial) {
      this.form.neonatal_esensial = { ...empty.neonatal_esensial, ...content.neonatal_esensial };
    }
    if (content.skrining) {
      this.form.skrining = { ...empty.skrining, ...content.skrining };
    }
    if (content.first_output) {
      this.form.first_output = { ...empty.first_output, ...content.first_output };
    }
    if (content.diagnosis_icd) {
      this.form.diagnosis_icd = {
        primer: { ...empty.diagnosis_icd.primer, ...(content.diagnosis_icd.primer || {}) },
        sekunder: Array.isArray(content.diagnosis_icd.sekunder) ? content.diagnosis_icd.sekunder : []
      };
    }

    // Ekstremitas
    const eksKeys = Object.keys(this.ekstremitasLabels);
    eksKeys.forEach(key => {
      if (content.ekstremitas && content.ekstremitas[key]) {
        this.form.ekstremitas[key] = { ...this.getEmptyEkstremitas(), ...content.ekstremitas[key] };
      }
    });

    // Pemeriksaan Tambahan
    if (content.pemeriksaan_tambahan) {
      this.form.pemeriksaan_tambahan = { ...this.getEmptyForm().pemeriksaan_tambahan, ...content.pemeriksaan_tambahan };
    }

    // Refleks
    if (content.refleks_primitif) {
      this.form.refleks_primitif = { ...this.getEmptyForm().refleks_primitif, ...content.refleks_primitif };
    }

    // Dubowitz
    if (content.dubowitz_neuro) {
      this.form.dubowitz_neuro = { ...this.getEmptyForm().dubowitz_neuro, ...content.dubowitz_neuro };
    }
    if (content.dubowitz_fisik) {
      this.form.dubowitz_fisik = { ...this.getEmptyForm().dubowitz_fisik, ...content.dubowitz_fisik };
    }
  }

  getEmptyForm() {
    return {
      sikap_bayi: null,
      nadi: null,
      suhu: null,
      pernapasan: null,
      diagnosis: null,
      rencana_tindakan: null,
      dokter_id: userModule.isMedis ? userModule.user?.id : null,
      // Identitas & status kelahiran
      jenis_kelahiran: null,
      urutan_kembar: null,
      status_bayi: "hidup",
      // Antropometri lahir
      berat_lahir_gram: null,
      panjang_badan_cm: null,
      lingkar_kepala_cm: null,
      lingkar_dada_cm: null,
      // Usia kehamilan (HPHT)
      usia_kehamilan_minggu: null,
      usia_kehamilan_hari: null,
      // Klasifikasi BB thd UK (manual: SGA/AGA/LGA)
      klasifikasi_bb_uk: null,
      // Flag laporan
      resusitasi_dilakukan: false,
      // APGAR (komponen 0-2 per waktu)
      apgar: {
        menit_1: { djantung: null, napas: null, tonus: null, reflex: null, warna: null },
        menit_5: { djantung: null, napas: null, tonus: null, reflex: null, warna: null },
        menit_10: { djantung: null, napas: null, tonus: null, reflex: null, warna: null }
      },
      // Resusitasi NRP
      resusitasi: {
        langkah_awal: false, suction: false, oksigen: false, vtp: false,
        kompresi: false, intubasi: false, obat: false, akses_vena: false,
        durasi_menit: null, hasil: null, disposisi: null
      },
      // Pelayanan Neonatal Esensial
      neonatal_esensial: {
        imd: false, salep_mata: false, vit_k: false, hb0: false,
        hbig: false, arv: false, tali_pusat: false, hipotermia: false
      },
      // Skrining BBL
      skrining: { shk: null, g6pd: null, oae: null, cchd: null },
      // Pengeluaran pertama
      first_output: { bak_jam: null, bab_jam: null, karakteristik: null },
      // Diagnosis ICD
      diagnosis_icd: { primer: { kode: null, nama: null }, sekunder: [] },
      anamnesis: {
        keluhan_utama: "",
        riwayat_kehamilan: "",
        riwayat_penyakit: "",
        skema_keluarga: "",
        keadaan_umum: ""
      },
      pemeriksaan_fisik: {
        kulit: "", kepala: "", mata: "", hidung: "", telinga: "",
        mulut_lidah: "", leher: "", dada: "", jantung: "", paru: "",
        perut: "", hati: "", limpa: "", anus: "", genital: ""
      },
      ekstremitas: {
        superior_kanan: this.getEmptyEkstremitas(),
        superior_kiri: this.getEmptyEkstremitas(),
        inferior_kanan: this.getEmptyEkstremitas(),
        inferior_kiri: this.getEmptyEkstremitas()
      },
      pemeriksaan_tambahan: {
        suara_jantung: null, oedem: false
      },
      refleks_primitif: {
        moro: null, memegang: null, menghisap: null, tonik_leher: null, plantar: null
      },
      kelainan_lain: "",
      dubowitz_neuro: {
        sikap_posture: null, sudut_radiokarpal: null, arm_recoil: null,
        dorsofleksi_tumit: null, sudut_poplitea: null, leg_recoil: null,
        heel_to_ear: null, scarf_sign: null, head_lag: null, ventral_suspension: null
      },
      dubowitz_fisik: {
        udem: null, elastisitas_kulit: null, warna_kulit: null,
        venae_abdomen: null, lanugo: null, lipat_plantar: null,
        papila_mamae: null, kelenjar_mamae: null, bentuk_telinga: null,
        konsistensi_telinga: null, organ_genitalia: null
      }
    };
  }

  getEmptyEkstremitas() {
    return { tonus: "", trofi: "", klonus: "", refleks_fisiologis: "", refleks_patologis: "" };
  }

  get requestParams() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateUser?.unit_id,
      examined_at: this.formattedExaminedAt,
      // Link ibu -> bayi (hanya saat dibuka dari Asesmen Awal Kebidanan)
      ibu_register_id: this.ibuRegister || null,
      ibu_pasien_rm: this.ibuRegister ? this.ibuRm || null : null,
      // Identitas & status kelahiran
      jam_lahir: this.formattedJamLahir,
      jenis_kelahiran: this.form.jenis_kelahiran,
      urutan_kembar: this.form.urutan_kembar,
      status_bayi: this.form.status_bayi,
      deceased_at: this.form.status_bayi === "mati" ? this.formattedDeceasedAt : null,
      // Antropometri
      berat_lahir_gram: this.form.berat_lahir_gram,
      panjang_badan_cm: this.form.panjang_badan_cm,
      lingkar_kepala_cm: this.form.lingkar_kepala_cm,
      lingkar_dada_cm: this.form.lingkar_dada_cm,
      // Usia kehamilan
      usia_kehamilan_minggu: this.form.usia_kehamilan_minggu,
      usia_kehamilan_hari: this.form.usia_kehamilan_hari,
      // Klasifikasi manual SGA/AGA/LGA (gestasi & berat dihitung server)
      klasifikasi_bb_uk: this.form.klasifikasi_bb_uk,
      // Flag laporan
      resusitasi_dilakukan: this.form.resusitasi_dilakukan,
      sikap_bayi: this.form.sikap_bayi,
      nadi: this.form.nadi,
      suhu: this.form.suhu,
      pernapasan: this.form.pernapasan,
      diagnosis: this.form.diagnosis,
      rencana_tindakan: this.form.rencana_tindakan,
      dokter_id: this.form.dokter_id,
      content: {
        anamnesis: this.form.anamnesis,
        pemeriksaan_fisik: this.form.pemeriksaan_fisik,
        ekstremitas: this.form.ekstremitas,
        pemeriksaan_tambahan: this.form.pemeriksaan_tambahan,
        refleks_primitif: this.form.refleks_primitif,
        kelainan_lain: this.form.kelainan_lain,
        dubowitz_neuro: this.form.dubowitz_neuro,
        dubowitz_fisik: this.form.dubowitz_fisik,
        apgar: this.form.apgar,
        resusitasi: this.form.resusitasi,
        neonatal_esensial: this.form.neonatal_esensial,
        skrining: this.form.skrining,
        first_output: this.form.first_output,
        diagnosis_icd: this.form.diagnosis_icd
      }
    };
  }

  async save() {
    if (this.saving) return;
    this.saving = true;

    try {
      const sendRequest = this.record
        ? AsesmenAwalBayiBaruLahirSvc.update(this.record.id, this.requestParams)
        : AsesmenAwalBayiBaruLahirSvc.create(this.requestParams);

      await sendRequest;
      appModule.NoticeDelay("Berhasil Simpan Asesmen Bayi Baru Lahir");
      this.isEditing = false;
      await this.loadData();
      this.$emit("saved");
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (this.removing || !this.record) return;
    if (!this.canDelete) return;
    const confirmed = confirmRemove("Asesmen Awal Bayi Baru Lahir");
    if (!confirmed) return;

    this.removing = true;
    try {
      await AsesmenAwalBayiBaruLahirSvc.destroy(this.record.id);
      appModule.NoticeDelay("Berhasil Hapus Asesmen Bayi Baru Lahir");
      await AsesmenAwalBayiBaruLahirStore.reset();
      this.form = this.getEmptyForm();
      this.examinedAt = null;
      this.jamLahir = null;
      this.deceasedAt = null;
      this.$emit("removed");
    } finally {
      this.removing = false;
    }
  }

  cancelEdit() {
    this.isEditing = false;
    if (this.record) {
      this.populateForm();
    }
  }

  cetakPdf() {
    if (this.record) {
      AsesmenAwalBayiBaruLahirSvc.printPdf(this.record.id);
    }
  }

  openTtd(role = "dokter") {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.record) return;
    const isPpja = this.signRole === "ppja";
    const signFn = isPpja
      ? AsesmenAwalBayiBaruLahirSvc.signPpja
      : AsesmenAwalBayiBaruLahirSvc.signDokter;
    const label = isPpja ? "PPJA" : "Dokter";
    try {
      const resp = await signFn(this.record.id, { password: password });
      if (resp.data?.status === "1") {
        appModule.NoticeDelay(`Berhasil TTD ${label}`);
        this.modalTtd = false;
        await this.loadData();
      } else {
        appModule.addMsgTtd(resp.data?.message || "Gagal TTD");
      }
    } catch (err) {
      // Error already handled by service ErrorAlert
    }
  }

  contentVal(path: string): string {
    if (!this.record?.content) return "-";
    const keys = path.split(".");
    let val: any = this.record.content;
    for (const k of keys) {
      if (val == null) return "-";
      val = val[k];
    }
    return val || "-";
  }

  contentBool(path: string): boolean {
    if (!this.record?.content) return false;
    const keys = path.split(".");
    let val: any = this.record.content;
    for (const k of keys) {
      if (val == null) return false;
      val = val[k];
    }
    return val === true || val === 1 || val === "1";
  }

  klasifikasiGestasiLabel(kode: string): string {
    const map = {
      sangat_preterm: "Sangat Preterm",
      preterm: "Preterm",
      aterm: "Aterm",
      postterm: "Postterm"
    };
    return map[kode] || "Gestasi: -";
  }

  klasifikasiBeratLabel(kode: string): string {
    const map = {
      bbln: "BBLN",
      bblr: "BBLR",
      bblsr: "BBLSR",
      bblasr: "BBLASR"
    };
    return map[kode] || "Berat: -";
  }

  apgarInterpretasiLabel(kode: string): string {
    const map = {
      vigorous: "Vigorous / Normal (7–10)",
      asfiksia_ringan_sedang: "Asfiksia Ringan-Sedang (4–6)",
      asfiksia_berat: "Asfiksia Berat (0–3)"
    };
    return map[kode] || "-";
  }

  generateRange(min: number, max: number): number[] {
    const arr: number[] = [];
    for (let i = min; i <= max; i++) {
      arr.push(i);
    }
    return arr;
  }

  dubowitzToGestationalAge = dubowitzToGestationalAge;
  gestationalChipColor = gestationalChipColor;
  gestationalLabel = gestationalLabel;
}
